import { forwardRef } from "react";
import { StyledHeading } from "./Heading.style.js";
import { DefaultHeadingProps, HeadingProps, HeadingSize, HeadingWeight } from "./Heading.types.js";

const defaultProps: DefaultHeadingProps = {
    color: "inherit",
    size: HeadingSize.MEDIUM,
    weight: HeadingWeight.NORMAL,
    align: "inherit",
};

export const Heading = forwardRef<HTMLHeadingElement, HeadingProps>((props, ref): JSX.Element => {
    const { children, ...attributes } = { ...defaultProps, ...props };

    return (
        <StyledHeading ref={ref} {...attributes}>
            {children}
        </StyledHeading>
    );
});
